module.exports = __webpack_public_path__ + "e8395bfe45da94e45c3305940f0df1af.svg";